import { createSelector } from "reselect";

const selectRaw = (state) => state.app;

const selectUserBlogs = createSelector([selectRaw], (app) => app.blogs);
const selectSavedBlog = createSelector([selectRaw], (app) => ({
  videoId: app.videoId,
  videoTopic: app.topic,
  videoTitle: app.title,
}));
const selectLoading = createSelector([selectRaw], (app) => app.loading);
const selectors = {
  selectRaw,
  selectLoading,
  selectUserBlogs,
  selectSavedBlog,
};

export default selectors;
